import styled from 'styled-components';

export const UnstyledButton = styled.button`
  padding: 0;
  appearance: none;
  background: none;
  border: none;
  &:not([disabled]) {
    cursor: pointer;
  }
`;
